import { Injectable } from '@angular/core';
// import Heimdall from '@ecs/heimdall';
// import { getProduct, Product } from './header-product';
// import { Product } from '../../models/Product';

@Injectable({
    providedIn: 'root'
})
export class HeaderSerasaService {
    // public getProduct(name: string): Product {
    //     return getProduct(name);
    // }

    public build(config, element) {
        // return new Heimdall(config, element);
    }
}
